/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */


import React, { useState, useEffect, useCallback, useImperativeHandle, useRef } from 'react';
import clsx from "clsx";
import { emptyValidation, customNumberValidation } from "../../../../../helpers/validation";
import customStyles from "../../../../../assets/styles/customStyles";
import { Col, Image, Row, Space } from "antd";
import {
    Button, TextField, Box, Switch, FormControlLabel, Typography,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, FormControl, RadioGroup, Radio, FormLabel
} from "@mui/material";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import crudActions from "../../../../CRUD/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import adminActions from "../../../../YounoteAdmin/Product/redux/actions";
import purchaseActions from "../../../../Purchase/Management/redux/actions";
import { getBusinessId, capitalizeFirstLetter, checkCRUDPermission, scrollToError, getColumnWidth, idNamingConversion } from '../../../../../helpers/utilities';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";
import usePrevious from "../../../../Shared/components/Previous";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import { toast } from 'react-toastify';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { UnitForm } from './UnitForm';
import { BatchForm } from './BatchForm';
import { NavLink, Link } from "react-router-dom";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import FileUpload from "../../../../Shared/components/FileUpload";
import { productUnitConversionHead } from "../../../../../config/constant";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import dayjs from 'dayjs';
import { AESEncrypt } from "../../../../../helpers/Crypto";



export const CustomForm = React.forwardRef((props, ref) => {
    const { view, productId, showDetails, type, history, roleManagement } = props;
    const childRef = useRef('');
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, createData } = useSelector(state => state.crudReducer);
    const { businessDetails, parameterDetails } = useSelector(state => state.homeReducer);

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const { productGstdetails, hsnDetails } = useSelector(state => state.adminSetupReducer);
    const { catalogueDetails, categoryDetails } = useSelector(state => state.younoteAdminProductReducer);
    const { unitMesurementdetails, unitClassdetails, productUnitConversionLoader, productUnitConversiondetails, productGroupDetails } = useSelector(state => state.productSetupReducer);
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);
    const classes = customStyles();
    const dispatch = useDispatch();
    const [unitVisible, setUnitVisible] = useState(false);
    const [batchVisible, setBatchVisible] = useState(false);
    const [batch, setBatch] = useState([]);
    const [primaryTitle, setPrimaryTitle] = useState('Add');
    const [unitId, setUnitId] = useState('');
    const [batchId, setBatchId] = useState('');
    const [useMrp, setUseMrp] = useState(false);
    const [formType, setFormType] = useState('product');
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    //const [unitSkip, setUnitSkip] = useState(0);
    //const [batchSkip, setBatchSkip] = useState(0);
    const [unitSortOrder, setUnitSortOrder] = useState("desc");
    const [unitSortBy, setUnitSortBy] = useState("id");
    const [formView, setFormView] = useState(false);
    const [unitFormRelation, setUnitFormRelation] = useState({});
    const [addMore, setAddMore] = useState(false);

    const [form, setForm] = useState({
        "businessId": getBusinessId(),
        "status": "ACTIVE",
        "batchActivation": false,
        "taxApplicable": false,
        "exciseApplicable": false
    });

    const [formRelation, setFormRelation] = useState({});

    const [unitForm, setUnitForm] = useState({});
    const [unitError, setUnitError] = useState({});
    const [batchForm, setBatchForm] = useState({});
    const [batchError, setBatchError] = useState({});
    const [error, setError] = useState({});

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        loadTasks();
        return () => {
            dispatch({
                type: adminActions.CLEAR_ADMIN_PRODUCT_DETAILS_START,
            });
        };
    }, []);


    const emptyState = () => {
        setError({});
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            // if (name === 'hsnId') {
            //     let a = hsnDetails?.length > 0 && hsnDetails.filter(function (el) { return el.id === e });
            //     if (a && a?.length !== 0) {
            //         setForm({
            //             ...form,
            //             [name]: e,
            //             'productGstId': a[0].productGstId
            //         });
            //     }
            // } else 
            if (name === 'categoryId') {
                let a = categoryDetails?.length > 0 && categoryDetails.filter(function (el) { return el.id === e });
                if (a && a?.length !== 0) {
                    setForm({
                        ...form,
                        [name]: e,
                        'catalogueId': a[0].catalogueId
                    });
                }
            } else {
                setForm({
                    ...form,
                    [name]: e,
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: (e.target.type === 'number' || e.target.name === 'batchActivation') && e.target.value !== '' ? parseFloat(e.target.value) : e.target.value,
            });
        }
    }

    const changeUnitHandler = (e, name = '') => {
        if (name !== '') {
            setUnitForm({
                ...unitForm,
                [name]: e,
            });
        } else {
            setUnitForm({
                ...unitForm,
                [e.target.name]: e.target.value
            });
        }

    }

    const changeBatchHandler = (e, name = '') => {
        if (name !== '') {
            setBatchForm({
                ...batchForm,
                [name]: e,
            });
        } else {
            setBatchForm({
                ...batchForm,
                [e.target.name]: e.target.value,
            });
        }
    }

    const requestSort = (sortBy, sortOrder) => {
        setUnitSortBy(sortBy);
        setUnitSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const submitProduct = (e) => {
        e.preventDefault();
        childRef?.current?.handleAdjustHeight();
        setFormType("product");
        let emptyProductName = emptyValidation('Product Name', form.productName);
        //let emptyProductdescription = emptyValidation('Description', form.description);
        let emptyType = emptyValidation('Type', form.type, 'dropDown');
        let emptySkuQuantity = customNumberValidation('SKU Quantity', form.skuQuantity);
        let emptySkuUnitId = emptyValidation('SKU Unit', form.skuUnitId, 'dropDown');
        let emptySalesUnitId = emptyValidation('Sales Unit', form.salesUnitId, 'dropDown');
        let emptyMrp = customNumberValidation('MRP', form.mrp);
        // let emptyCostPrice = customNumberValidation('Cost Price', form.costPrice);
        // let emptyLatestPurchasePrice = customNumberValidation('Latest Purchase Price', form.latestPurchasePrice);
        let sku = true;
        let price = true;
        if (form.type === 'ITEM' && !emptySkuQuantity.isValid) {
            sku = false;
        }
        if (useMrp && !emptyMrp.isValid) {
            price = false;
        }

        emptyState();
        if (emptyProductName.isValid && emptyType.isValid &&
            sku && emptySkuUnitId.isValid && emptySalesUnitId.isValid && price) {
            form.useMrp = useMrp;
            form.mrp = form.mrp ? parseFloat(form.mrp) : null;
            form.costPrice = form.costPrice ? parseFloat(form.costPrice) : null;
            form.skuQuantity = form.skuQuantity ? parseFloat(form.skuQuantity) : null;
            form.latestPurchasePrice = form.latestPurchasePrice ? parseFloat(form.latestPurchasePrice) : null;

            if (productId) {
                form.hsnId = form?.hsnId || null;
                form.catalogueId = form?.catalogueId || null;
                form.productGstId = form?.productGstId || null;
                form.universalProductId = form?.universalProductId || null;
                form.productGroupId = form?.productGroupId || null;
                form.preferredSupplierId = form?.preferredSupplierId || null;
            }

            // let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));
            form.transType = form?.transType || null;
            form.defaultSalesUnitId = form?.defaultSalesUnitId || 0;
            form.defaultPurchaseUnitId = form?.defaultPurchaseUnitId || 0;
            form.code = form?.code || '';
            delete form.universalProductId;
            if (form?.categoryId) {
                let a = customObject(categoryList, form?.categoryId);
                if (a && a?.brandId) {
                    form.brandId = a?.brandId;
                }
            }

            dispatch({
                type: productId === undefined ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: "client-products",
                id: productId,
                title: "Client Products",
                details: form
            })
        } else {
            setError({
                ...error,
                'productName': emptyProductName.errors,
                'type': emptyType.errors,
                'skuQuantity': form.type === 'ITEM' && emptySkuQuantity.errors ? emptySkuQuantity.errors : '',
                'skuUnitId': emptySkuUnitId.errors,
                'salesUnitId': emptySalesUnitId.errors,
                'mrp': useMrp && emptyMrp.errors,
                // 'costPrice': useMrp && emptyCostPrice.errors,
                // 'latestPurchasePrice': useMrp && emptyLatestPurchasePrice.errors,
            });
            scrollToError();
        }
    }

    const loadTasks = useCallback(() => {
        if (type === 'create') {
            hsnApi('');
        }
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, filter: {
                order: 'id desc',
            }
        });
        dispatch({
            type: gstActions.TAXCODE_DETAILS_START, filter: {
                order: 'id desc',
            }
        });
        dispatch({
            type: adminActions.CATALOGUE_DETAILS_START, filter: {
                order: 'id desc',
            }
        });
        // dispatch({ type: adminActions.CATEGORY_DETAILS_START });
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id desc',
            }
        });
        dispatch({
            type: unitActions.UNITCLASS_DETAILS_START, url: 'unitclass', filter: {
                order: 'id desc',
            }
        });
        dispatch({
            type: unitActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                order: 'id desc',
            }
        });
        dispatch({
            type: purchaseActions.SUPPLIER_DETAILS_START, url: 'supplierProfile', filter: {
                order: 'id desc',
            }
        });
        dispatchFilter(unitSortBy, unitSortOrder);
    });

    const hsnApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: filter,
                order: 'hsnCode asc',
                limit: 500,
                skip: 0
            },
        });
    }


    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        let filter = { ["and"]: [{ productId: productId !== undefined ? productId : 0 }] };
        childRef?.current?.handleAdjustHeight();
        dispatch({
            type: unitActions.PRODUCT_UNITCONVERSION_DETAILS_START,
            url: 'product-unit-conversions',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder
            }
        });
    }


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            handleOpen(formType);
            if (formType === 'unit') {
                //toast(`${capitalizeFirstLetter(formType)} has been added successfully`);
                dispatchFilter(unitSortBy, unitSortOrder);
                if (addMore) {
                    setTimeout(() => {
                        setPrimaryTitle('Add'); handleOpen('unit'); setAddMore(false);
                    }, 500);
                }
            } else if (formType === 'batch') {
                if (addMore) {
                    setTimeout(() => {
                        setPrimaryTitle('Add'); handleOpen('batch'); setAddMore(false);
                    }, 500);
                }
            } else {
                //toast(`"${createData.productName}" has been added successfully`);
                history.push(`/product/product/my-products/${AESEncrypt(createData.id)}/view`, `${type}`);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            if (formType === 'unit') {
                setUnitError({
                    "common": text
                });
            } else if (formType === 'batch') {

            } else {
                if (text.includes("CLIENT_PRODUCT_ID_UNIQUE")) {
                    setError({
                        ...error,
                        "productId": "ProductId already exits"
                    })
                } else if (text.includes("CLIENT_PRODUCT_UNIQUE")) {
                    setError({
                        ...error,
                        "productName": "Product Name already exits"
                    })
                } else {
                    setError({
                        "common": text
                    })
                }
            }
        }
        childRef?.current?.handleAdjustHeight();
    }, [createDetails, createError]);

    useEffect(() => {
        let a = categoryDetails.length > 0 ? categoryDetails.filter((el) => { return !el.hasSubCategories }) : [];
        setCategoryList(a);
    }, [categoryDetails]);

    useEffect(() => {
        childRef?.current?.handleAdjustHeight();
    }, [type]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            handleOpen(formType);
            if (formType === 'unit') {
                // toast(`${capitalizeFirstLetter(formType)} has been updated successfully`);
                dispatchFilter(unitSortBy, unitSortOrder);
            } else if (formType === 'batch') {

            } else {
                // toast(`"${form.productName}" has been updated successfully`);
                if (roleManagement !== '' && checkCRUDPermission('My Products', 'view', 'Product')) {
                    history.push(`/product/product/my-products/${AESEncrypt(productId)}/view`, `${type}`);
                } else {
                    history.push(`/product/product/my-products/`);
                }
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            if (text.includes("CLIENT_PRODUCT_ID_UNIQUE")) {
                setError({
                    ...error,
                    "productId": "ProductId already exits"
                })
            } else if (text.includes("CLIENT_PRODUCT_UNIQUE")) {
                setError({
                    ...error,
                    "productName": "Product Name already exits"
                })
            } else {
                setError({
                    "common": text
                })
            }
        }
        childRef?.current?.handleAdjustHeight();
    }, [editDetails, editError]);

    useImperativeHandle(ref, () => ({
        onEdit(data) {
            let result = {
                "productName": data?.productName || '',
                "description": data?.description || '',
                "type": data?.type || '',
                "imageUri": data?.imageUri || '',
                "productId": data?.productId || '',
                "catalogueId": data?.catalogueId || null,
                "categoryId": data?.categoryId || null,
                "hsnId": data?.hsnId || null,
                "productGstId": data?.productGstId || null,
                "productGroupId": data?.productGroupId || null,
                "skuUnitId": data?.skuUnitId || null,
                "salesUnitId": data?.salesUnitId || null,
                "skuQuantity": data?.skuQuantity,
                "batchActivation": data?.batchActivation || false,
                "preferredSupplierId": data?.preferredSupplierId || null,
                "universalProductId": data?.universalProductId || null,
                "status": data?.status,
                "mrp": data?.mrp || null,
                "code": data?.code || '',
                "barcode": data?.barcode || '',
                "ianNumber": data?.ianNumber || '',
                "costPrice": data?.costPrice || null,
                "transType": data?.transType || '',
                "latestPurchasePrice": data?.latestPurchasePrice || null,
                "priceIncludesTax": data.priceIncludesTax ? true : false,
                "defaultSalesUnitId": data?.defaultSalesUnitId || 0,
                "defaultPurchaseUnitId": data?.defaultPurchaseUnitId || 0,
                "exciseApplicable": data.exciseApplicable ? true : false,
            };
            if (data?.sellEndDate) {
                result["sellEndDate"] = dayjs(data?.sellEndDate).$d;
            }
            if (data?.mrpLastUpdatedDate) {
                result["mrpLastUpdatedDate"] = dayjs(data?.mrpLastUpdatedDate).$d;
            }
            if (data?.costLastUpdatedDate) {
                result["costLastUpdatedDate"] = dayjs(data?.costLastUpdatedDate).$d;
            }
            if (data?.latestPurchasePriceTs) {
                result["latestPurchasePriceTs"] = dayjs(data?.latestPurchasePriceTs).$d;
            }
            setForm(result);
            hsnApi('', data?.hsnId);
            setUseMrp(data?.useMrp);
            changeCatalogueHandler(parseInt(data?.catalogueId));
            setFormRelation({
                "catalogue": data?.catalogue?.catalogueName,
                "category": data?.category?.categoryName,
                "hsn": data?.hsn?.hsnCode,
                "productGst": data?.productGst?.code,
                "skuUnit": data?.skuUnit?.name,
                "salesUnit": data?.salesUnit?.name,
                "defaultPurchaseUnit": data?.defaultPurchaseUnit?.name,
                "defaultSalesUnit": data?.defaultSalesUnit?.name,
                "preferredSupplier": data?.preferredSupplier?.name,
                "productGroup": data?.productGroup?.name,
                "taxCode": data?.taxCode?.code,
                "universalProduct": data?.universalProduct?.productId,
            });
        },
        submitProduct(e) {
            submitProduct(e)
        },
        reSize() {
            childRef?.current?.handleAdjustHeight();
        }
    }));

    const handleUnitSubmit = (e) => {
        e.preventDefault();
        childRef?.current?.handleAdjustHeight();
        let emptyUnit = emptyValidation('Unit', unitForm.unitId);
        let emptyToUnit = emptyValidation('Unit', unitForm.toUnitId);
        let emptyConversionFactor = emptyValidation('Conversion Factor', unitForm.conversionFactor);
        setUnitError({});
        if (emptyUnit.isValid && emptyToUnit.isValid && emptyConversionFactor.isValid) {
            let data = Object.fromEntries(Object.entries(unitForm).filter(([_, v]) => v !== null && v !== ''));
            data['conversionFactor'] = parseFloat(data['conversionFactor']);
            data['additionalFactor'] = parseFloat(data['additionalFactor']);
            data['productId'] = parseInt(data['productId']);
            dispatch({
                type: unitId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'product-unit-conversions',
                title: 'Product unit conversions',
                id: unitId,
                details: data
            });
        } else {
            setUnitError({
                'unitId': emptyUnit.errors,
                'toUnitId': emptyToUnit.errors,
                'conversionFactor': emptyConversionFactor.errors,
            });
        }
    }



    const changeCatalogueHandler = (id, form = false) => {
        dispatch({
            type: adminActions.CATEGORY_DETAILS_START, filter: {
                where: { ["and"]: [{ catalogueId: id }] }
            }
        });

        if (form) {
            changeHandler(id, 'catalogueId');
        }
    }


    const handleOpen = (form) => {
        setFormView(false);
        if (productId === '') {
            toast.dismiss();
            toast.error("Please create product");
        } else {
            if (form === 'unit') {
                setUnitVisible(prev => !prev);
                setUnitError({});
                setUnitForm({
                    "productId": productId,
                    "additionalFactor": parseFloat(0.00).toFixed(2),
                    "conversionFactor": parseFloat(1.000000).toFixed(6)
                });
                setUnitFormRelation({});
                setUnitId('');
            } else if (form === 'batch') {
                setBatchVisible(prev => !prev);
                setBatchError({});
                setBatchId('');
                setBatchForm({ batchId: parseInt(batch.length + 1) });
            }
        }
        setFormType(form);
    }

    const onEdit = (form, data, view = false) => {
        setPrimaryTitle(view ? 'View' : 'Edit');
        handleOpen(form);
        if (form === 'unit') {
            setUnitForm({
                id: data?.id,
                productId: data?.productId,
                unitId: data?.unitId,
                toUnitId: data?.toUnitId,
                conversionFactor: data?.conversionFactor,
                additionalFactor: data?.additionalFactor
            });
            setUnitId(data?.id);
            setUnitFormRelation({
                unit: data?.unit?.name,
                toUnit: data?.toUnit?.name
            });
        } else if (form === 'batch') {
            setBatchForm({
                batchId: data?.batchId,
                batchNumber: data?.batchNumber,
                quantity: data?.quantity,
                expiryDate: data?.expiryDate,
                bestDate: data?.bestDate,
                mfgDate: data?.mfgDate
            });
            setBatchId(data?.batchId);
        }
        setFormView(view);
    }

    const handleDelete = (form, data) => {
        setFormType(form);
        setDeleteModalVisible(true);
        if (form === 'unit') {
            setUnitId(data.id);
        } else {
            setBatchId(data.batchId);
        }
    }

    const handleAddMore = (e, form) => {
        if (form === 'unit') {
            setAddMore(true);
            handleUnitSubmit(e);
        } else {
            setAddMore(true);
            handleBatchSubmit(e);
        }
    }

    const handleBatchSubmit = (e) => {
        e.preventDefault();
        childRef?.current?.handleAdjustHeight();
        let emptyQuantity = emptyValidation('Quantity', batchForm.quantity);
        let emptyMfgDate = emptyValidation('Batch Mfg. Date', batchForm.mfgDate);
        setBatchError({});
        if (emptyQuantity.isValid && emptyMfgDate.isValid) {
            if (batchId !== '') {
                let index = batch.findIndex((d, i) => batchId === d.batchId);
                if (index >= 0) {
                    batch.splice(index, 1, batchForm);
                }
            } else {
                setBatch((prevState) => {
                    return [...prevState, batchForm];
                });
            }
            handleOpen('batch');
        } else {
            setBatchError({
                'quantity': emptyQuantity.errors,
                'mfgDate': emptyMfgDate.errors
            });
        }
    }

    const handleProductEdit = (type) => {
        setFormType('product');
        history.push(`/product/product/my-products/${AESEncrypt(productId)}/${type}`, `${type}`);
    }

    return (
        <>
            <CustomAccordion
                title={`${capitalizeFirstLetter(type)} Product`}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => submitProduct(e)}>
                        {
                            !showDetails ?
                                <>
                                    <Row gutter={20}>
                                        <Col xxl={15} xl={15} lg={15} md={15} sm={15} xs={15}>
                                            <Row gutter={20}>
                                                {
                                                    error?.common && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}><CustomAlert error={error?.common} customClass={clsx(classes.uploadError, classes.marginBottom10)} /></Col>
                                                }
                                                {
                                                    view ? <>
                                                        <Col xxl={10} xl={10} lg={8} md={8} sm={10} xs={24}>
                                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize16, classes.bold)}>{form.productName}</Typography>
                                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize13, classes.margin10t, classes.productNameView)}>{form?.productId}{form.type && <span>{form.type}</span>}{form.code && <span>{form.code}</span>} {form.transType && <span>{form.transType === 'SALES' ? 'Sales only' : 'Purchase only'}</span>}</Typography>
                                                        </Col>
                                                    </> : <></>
                                                }
                                                {
                                                    view ? <></> :
                                                        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24} className={classes.positionRelative}>
                                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product ID</Typography>
                                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.productId || '---'}</Typography>
                                                        </Col>
                                                }
                                                {
                                                    view ?
                                                        <></> :
                                                        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                            <AutoCompleteComponent
                                                                name={["Product Type ", <span key={'Product Type'} className={classes.colorRedRequired}> *</span>]}
                                                                heads={[{ 'key': 'label', 'name': 'Product Type' }]}
                                                                details={[{ "id": "ITEM", "label": "Item" }, { "id": "SERVICE", "label": "Service" }]}
                                                                parentValue={customObject([{ "id": "ITEM", "label": "Item" }, { "id": "SERVICE", "label": "Service" }], form.type)}
                                                                onChange={(data) => changeHandler(data.id, 'type')}
                                                                position={"bottom"}
                                                                id={idNamingConversion('Product Type', 'product', 'DropDown')}
                                                                parentError={error.type}
                                                            />
                                                        </Col>
                                                }
                                                {
                                                    view ?
                                                        <></> :
                                                        <Col xxl={8} xl={8} lg={24} md={24} sm={24} xs={24}>
                                                            <TextField autoComplete='one-time-code'
                                                                label={["Product Code "]}
                                                                variant={'standard'}
                                                                name={"code"}
                                                                fullWidth
                                                                className={clsx(classes.productCode)}
                                                                value={form?.code || ''}
                                                                inputProps={{ maxLength: 20 }}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                id={idNamingConversion('Product Code', 'product', 'TextField')}
                                                                onChange={(e) => changeHandler(e)}
                                                            />
                                                        </Col>
                                                }
                                            </Row>
                                        </Col>
                                        <Col xxl={9} xl={9} lg={9} md={9} sm={9} xs={9} style={{ height: "100%" }}>
                                            <Row>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.textAlignRight, classes.positionAbsolute)}>
                                                    {
                                                        type === 'create' && <Button
                                                            tabIndex={-1}
                                                            key="save"
                                                            color="primary"
                                                            variant="contained"
                                                            type={'submit'}
                                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                                        >Save</Button>
                                                    }
                                                    {
                                                        type === 'edit' && <Space direction="horizontal" align="center">
                                                            {
                                                                roleManagement !== '' && checkCRUDPermission('My Products', 'view', 'Product') &&
                                                                <Link onClick={() => handleProductEdit('view')} to={`#`}
                                                                    className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0)}>Cancel</Link>
                                                            }
                                                            <Button
                                                                key="save"
                                                                color="primary"
                                                                variant="contained"
                                                                type={'submit'}
                                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                                                            >Update</Button></Space>
                                                    }
                                                    {
                                                        type === 'view' && <Space direction="horizontal" align="center">
                                                            {
                                                                roleManagement !== '' && checkCRUDPermission('My Products', 'deletable', 'Product') &&
                                                                <Button
                                                                    key="save"
                                                                    color="primary"
                                                                    variant="contained"
                                                                    onClick={() => { setDeleteModal(true) }}
                                                                    className={clsx(classes.deleteBtn)}
                                                                >Delete</Button>
                                                            }
                                                            {
                                                                roleManagement !== '' && checkCRUDPermission('My Products', 'edit', 'Product') &&
                                                                <Link onClick={() => handleProductEdit('edit')} to={'#'}
                                                                    className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0)}>Edit</Link>
                                                            }
                                                        </Space>
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>



                                    </Row>
                                    <Row type="flex" className={clsx(classes.productFormImageRow)} gutter={50}>
                                        <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                                            <Row gutter={20}>
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <></> :
                                                            <TextField autoComplete='one-time-code'
                                                                label={["Product Name ", <span key={'Product Name'} className={classes.colorRedRequired}> *</span>]}
                                                                variant={'standard'}
                                                                className={clsx(classes.margin20t)}
                                                                error={error.productName ? true : false}
                                                                helperText={error.productName}
                                                                name={"productName"}
                                                                fullWidth
                                                                value={form?.productName || ''}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                id={idNamingConversion('Product Name', 'product', 'TextField')}
                                                                onChange={(e) => changeHandler(e)}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <></> :
                                                            <AutoCompleteComponent
                                                                name={["Trans type "]}
                                                                heads={[{ 'key': 'label', 'name': 'Trans type' }]}
                                                                details={[{ "id": "PURCHASE", "label": "Purchase only" }, { "id": "SALES", "label": "Sales only" }]}
                                                                parentValue={customObject([{ "id": "PURCHASE", "label": "Purchase only" }, { "id": "SALES", "label": "Sales only" }], form?.transType || '')}
                                                                onChange={(data) => changeHandler(data.id, 'transType')}
                                                                position={"bottom"}
                                                                id={idNamingConversion('Trans type', 'product', 'DropDown')}
                                                                parentError={error.type}
                                                                customClasses={classes.margin20t}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description || '---'}</Typography>
                                                            </> :
                                                            <TextField autoComplete='one-time-code'
                                                                label='Description'
                                                                name={"description"}
                                                                value={form?.description || ''}
                                                                error={error.description ? true : false}
                                                                helperText={error.description}
                                                                multiline
                                                                variant="outlined"
                                                                fullWidth
                                                                className={clsx(classes.margin20t, classes.customDescription)}
                                                                rows={2}
                                                                id={idNamingConversion('Description', 'product', 'TextField')}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    }
                                                                }}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColor,
                                                                }}
                                                                onChange={(e) => changeHandler(e)}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Quantity</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.skuQuantity || '---'}</Typography>
                                                            </> :
                                                            <TextField autoComplete='one-time-code'
                                                                label={form?.type === 'ITEM' ? ["SKU Quantity ", <span key={"SKU Quantity"} className={classes.colorRedRequired}> *</span>] : "SKU Quantity"}
                                                                variant={'standard'}
                                                                fullWidth
                                                                className={clsx(classes.margin20t)}
                                                                name={"skuQuantity"}
                                                                onWheel={(e) => e.target.blur()}
                                                                value={form?.skuQuantity || ''}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    },
                                                                    inputProps: { step: "any" }
                                                                }}
                                                                id={idNamingConversion('SKU Quantity', 'product', 'TextField')}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                onChange={(e) => changeHandler(e)}
                                                                error={error.skuQuantity ? true : false}
                                                                helperText={error.skuQuantity}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SKU Unit</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {formRelation.skuUnit}
                                                                </Typography>
                                                            </> :
                                                            <AutoCompleteComponent
                                                                name={["SKU Unit ", <span key={'SKU Unit'} className={classes.colorRedRequired}> *</span>]}
                                                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                                                { 'key': 'description', 'name': 'Description' }]}
                                                                details={unitMesurementdetails}
                                                                parentValue={customObject(unitMesurementdetails, form?.skuUnitId)}
                                                                onChange={(data) => changeHandler(data.id, 'skuUnitId')}
                                                                position={"bottom"}
                                                                id={idNamingConversion('SKU Unit', 'product', 'DropDown')}
                                                                customClasses={classes.margin20t}
                                                                parentError={error.skuUnitId}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Unit</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {formRelation.salesUnit}
                                                                </Typography>
                                                            </> :
                                                            <AutoCompleteComponent
                                                                name={["Sales Unit ", <span key={'Sales Unit'} className={classes.colorRedRequired}> *</span>]}
                                                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                                                { 'key': 'description', 'name': 'Description' }]}
                                                                details={unitMesurementdetails}
                                                                parentValue={customObject(unitMesurementdetails, form?.salesUnitId)}
                                                                onChange={(data) => changeHandler(data.id, 'salesUnitId')}
                                                                position={"bottom"}
                                                                id={idNamingConversion('Sales Unit', 'product', 'DropDown')}
                                                                customClasses={classes.margin20t}
                                                                parentError={error.salesUnitId}
                                                            />
                                                    }
                                                </Col>
                                                {
                                                    parameterDetails?.defaultUnits ? <>
                                                        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                            {console.log('form', form)}
                                                            {
                                                                view ?
                                                                    <>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Default Sales Unit</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                            {formRelation.defaultSalesUnit || '---'}
                                                                        </Typography>
                                                                    </> :
                                                                    <AutoCompleteComponent
                                                                        name={["Default Sales Unit "]}
                                                                        heads={[{ 'key': 'name', 'name': 'Unit' },
                                                                        { 'key': 'description', 'name': 'Description' }]}
                                                                        details={unitMesurementdetails}
                                                                        parentValue={customObject(unitMesurementdetails, form?.defaultSalesUnitId)}
                                                                        onChange={(data) => changeHandler(data.id, 'defaultSalesUnitId')}
                                                                        position={"bottom"}
                                                                        id={idNamingConversion('Default Sales Unit', 'product', 'DropDown')}
                                                                        customClasses={classes.margin20t}
                                                                    />
                                                            }
                                                        </Col>
                                                        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                            {
                                                                view ?
                                                                    <>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Default Purchase Unit</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                            {formRelation.defaultPurchaseUnit || '---'}
                                                                        </Typography>
                                                                    </> :
                                                                    <AutoCompleteComponent
                                                                        name={["Default Purchase Unit "]}
                                                                        heads={[{ 'key': 'name', 'name': 'Unit' },
                                                                        { 'key': 'description', 'name': 'Description' }]}
                                                                        details={unitMesurementdetails}
                                                                        parentValue={customObject(unitMesurementdetails, form?.defaultPurchaseUnitId)}
                                                                        onChange={(data) => changeHandler(data.id, 'defaultPurchaseUnitId')}
                                                                        position={"bottom"}
                                                                        id={idNamingConversion('Default Purchase Unit', 'product', 'DropDown')}
                                                                        customClasses={classes.margin20t}
                                                                    />
                                                            }
                                                        </Col>
                                                        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}></Col>
                                                    </> : null
                                                }

                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>HSN Code</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {formRelation.hsn || '---'}
                                                                </Typography>
                                                            </> :
                                                            <AutoCompleteComponent
                                                                name={["HSN Code"]}
                                                                heads={[{ 'key': 'hsnCode', 'name': 'HSN Code' },
                                                                { 'key': 'description', 'name': 'Description' }]}
                                                                details={hsnDetails}
                                                                id={idNamingConversion('HSN Code', 'product', 'DropDown')}
                                                                parentValue={customObject(hsnDetails, form?.hsnId)}
                                                                position={"top"}
                                                                topPosition={true}
                                                                searchType={(s) => hsnApi(s)}
                                                                customClasses={classes.margin20t}
                                                                onChange={(data) => changeHandler(data.id, 'hsnId')}
                                                                parentError={error.hsnId}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product GST Code</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {formRelation.productGst || '---'}
                                                                </Typography>
                                                            </> :
                                                            <AutoCompleteComponent
                                                                name={["Product GST"]}
                                                                heads={[{ 'key': 'code', 'name': 'Product GST Code' },
                                                                { 'key': 'percentage', 'name': 'Percentage', 'prefix': '%' }]}
                                                                details={productGstdetails}
                                                                id={idNamingConversion('Product GST', 'product', 'DropDown')}
                                                                parentValue={customObject(productGstdetails, form?.productGstId)}
                                                                onChange={(data) => changeHandler(data.id, 'productGstId')}
                                                                position={"top"}
                                                                topPosition={true}
                                                                customClasses={classes.margin20t}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <div className={clsx(classes.dateAdjust)}>
                                                        {
                                                            view ?
                                                                <>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales End Date</Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                        {form.sellEndDate ? moment(form.sellEndDate).format('DD MMM YYYY') : '---'}
                                                                    </Typography>
                                                                </> :
                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                    <DesktopDatePicker
                                                                        fullWidth
                                                                        slots={{
                                                                            openPickerIcon: DateIcon
                                                                        }}
                                                                        views={['year', 'month', 'day']}
                                                                        value={form?.sellEndDate || null}
                                                                        className={classes.margin20t}
                                                                        label="Sales End Date"
                                                                        name={"sellEndDate"}
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: classes.textFieldColor,
                                                                            }
                                                                        }}
                                                                        slotProps={{
                                                                            textField: {
                                                                                id: idNamingConversion('Sales End Date', 'product', 'TextField'),
                                                                                autoComplete: 'one-time-code'
                                                                            },
                                                                        }}
                                                                        format="dd/MM/yyyy"
                                                                        onChange={(newValue) => { changeHandler(newValue, 'sellEndDate') }}
                                                                    />
                                                                </LocalizationProvider>
                                                        }
                                                    </div>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product Group</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {formRelation.productGroup || '---'}</Typography>
                                                            </> :
                                                            <AutoCompleteComponent
                                                                name={["Product Group"]}
                                                                heads={[{ 'key': 'name', 'name': 'Name' }, { 'key': 'description', 'name': 'Description' }]}
                                                                details={productGroupDetails}
                                                                id={idNamingConversion('Product Group', 'product', 'DropDown')}
                                                                parentValue={customObject(productGroupDetails, form?.productGroupId)}
                                                                position={"top"}
                                                                customClasses={classes.margin20t}
                                                                onChange={(data) => changeHandler(data.id, 'productGroupId')}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Catalogue Name</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {formRelation.catalogue || '---'}</Typography>
                                                            </> :
                                                            <AutoCompleteComponent
                                                                name={["Catalogue Name"]}
                                                                heads={[{ 'key': 'catalogueName', 'name': 'Name' },
                                                                { 'key': 'cataloguePrefix', 'name': 'Prefix' }]}
                                                                details={catalogueDetails}
                                                                parentValue={customObject(catalogueDetails, form?.catalogueId)}
                                                                position={"top"}
                                                                id={idNamingConversion('Catalogue Name', 'product', 'DropDown')}
                                                                customClasses={classes.margin20t}
                                                                onChange={(data) => changeCatalogueHandler(data.id, 'catalogueId')}
                                                                parentError={error.catalogueId}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Category Name</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {formRelation.category || '---'}
                                                                </Typography>
                                                            </> :
                                                            <AutoCompleteComponent
                                                                name={["Category Name"]}
                                                                heads={[{ 'key': 'categoryName', 'name': 'Name' },
                                                                { 'key': 'parentName', 'name': 'Parent' },
                                                                { 'key': 'level', 'name': 'Levels', 'suffix': "Level " }]}
                                                                details={categoryList}
                                                                id={idNamingConversion('Category Name', 'product', 'DropDown')}
                                                                parentValue={customObject(categoryList, form?.categoryId)}
                                                                position={"top"}
                                                                customClasses={classes.margin20t}
                                                                onChange={(data) => changeHandler(data.id, 'categoryId')}
                                                                parentError={error.categoryId}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Preferred Supplier</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {formRelation?.preferredSupplier || '---'}
                                                                </Typography>
                                                            </> :
                                                            <AutoCompleteComponent
                                                                name={["Preferred Supplier"]}
                                                                heads={[{ 'key': 'name', 'name': 'Supplier Name' },
                                                                { 'key': 'mobile', 'name': 'Phone Number' },
                                                                { 'key': 'serialNo', 'name': 'Supplier ID' }]}
                                                                details={supplierDetails}
                                                                id={idNamingConversion('Preferred Supplier', 'product', 'DropDown')}
                                                                parentValue={customObject(supplierDetails, form?.preferredSupplierId)}
                                                                position={"top"}
                                                                topPosition={true}
                                                                customClasses={classes.margin20t}
                                                                parentError={error.preferredSupplierId}
                                                                onChange={(data) => changeHandler(data.id, 'preferredSupplierId')}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Universal Product ID</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{formRelation?.universalProduct || '---'}</Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {form?.status ? capitalizeFirstLetter(form?.status) : '---'}
                                                                </Typography>
                                                            </> :
                                                            <FormControl
                                                                tabIndex={-1}
                                                                className={clsx(classes.margin20t, classes.dropDownPointer, classes.customRadioButton)}
                                                                variant={'standard'}
                                                                fullWidth>
                                                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</FormLabel>
                                                                <RadioGroup row
                                                                    defaultValue="ACTIVE"
                                                                    aria-labelledby="demo-customized-radios"
                                                                    name="status"
                                                                    value={form?.status || false}
                                                                    onChange={(e) => changeHandler(e)}
                                                                    id={idNamingConversion('Status', 'product', 'Radio')}
                                                                >
                                                                    <FormControlLabel value="ACTIVE" control={<Radio
                                                                        checkedIcon={<UnSelectedIcon />}
                                                                        icon={<SelectedIcon />}
                                                                    />} label="Active" />
                                                                    <FormControlLabel value="INACTIVE" control={<Radio
                                                                        checkedIcon={<UnSelectedIcon />}
                                                                        icon={<SelectedIcon />}
                                                                    />} label="In-Active" />
                                                                </RadioGroup>
                                                            </FormControl>
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={12} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Batch Activation</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {form?.batchActivation ? 'Yes' : 'No'}
                                                                </Typography>
                                                            </> :
                                                            <FormControlLabel
                                                                classes={{
                                                                    label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                                                }}
                                                                control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                                    onChange={(e) => {
                                                                        setForm({ ...form, 'batchActivation': !form.batchActivation })
                                                                    }}
                                                                />}
                                                                id={idNamingConversion('Batch Activation', 'product', 'Radio')}
                                                                label="Batch Activation"
                                                                labelPlacement="top"
                                                                checked={form?.batchActivation}
                                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Bar Code</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.barcode || '---'}</Typography>
                                                            </> :
                                                            <TextField autoComplete='one-time-code'
                                                                label={["Bar Code "]}
                                                                variant={'standard'}
                                                                fullWidth
                                                                className={clsx(classes.margin20t)}
                                                                name={"barcode"}
                                                                value={form?.barcode || ''}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    }
                                                                }}
                                                                id={idNamingConversion('Bar Code', 'product', 'TextField')}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                onChange={(e) => changeHandler(e)}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>IAN Number </Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.ianNumber || '---'}</Typography>
                                                            </> :
                                                            <TextField autoComplete='one-time-code'
                                                                label={["IAN Number "]}
                                                                variant={'standard'}
                                                                fullWidth
                                                                className={clsx(classes.margin20t)}
                                                                name={"ianNumber"}
                                                                value={form?.ianNumber || ''}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    }
                                                                }}
                                                                id={idNamingConversion('ianNumber', 'product', 'TextField')}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                onChange={(e) => changeHandler(e)}
                                                            />
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xxl={9} xl={9} lg={9} md={24} sm={24} xs={24} style={{ height: "100%" }}>
                                            <div className={clsx(classes.productImageUpload, classes.dropDown)}>
                                                <div className={classes.productImageUploadInner}>
                                                    <FileUpload
                                                        filePath={form?.imageUri || ''}
                                                        handleChange={(value) => changeHandler(value, 'imageUri')}
                                                        types={'image/jpeg,image/png,image/gif'}
                                                        path={`client/${businessDetails?.serialNo}/myproduct/`}
                                                        maxSize={1}
                                                        square={false}
                                                        text={
                                                            <>
                                                                <p className={clsx(classes.textAreaLableColorUpload, classes.fonSize13)}>Product Image here</p>
                                                                <p className={clsx(classes.textAreaLableColorUpload, classes.fonSize11)}>(Image size : Not to exceed 1 MB)</p>
                                                            </>
                                                        }
                                                        alt={form?.productName}
                                                        view={view}
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row type="flex" style={{ verticalAlign: 'middle' }} className={clsx(classes.productFormImageRow)} gutter={50}>
                                        <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                                            <Row gutter={20}>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Prices</Typography>
                                                </Col>
                                            </Row>
                                            <Row gutter={20} className={classes.marginTop10}>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Use MRP</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {useMrp ? 'Yes' : 'No'}
                                                                </Typography>
                                                            </> :
                                                            <FormControlLabel
                                                                classes={{
                                                                    label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                                                }}
                                                                control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                                    onChange={(e) => setUseMrp(!useMrp)}
                                                                />}
                                                                id={idNamingConversion('Use MRP', 'product', 'Radio')}
                                                                label="Use MRP"
                                                                labelPlacement="top"
                                                                checked={useMrp}
                                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>MRP</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {form?.mrp || '---'}
                                                                </Typography>
                                                            </> :
                                                            <TextField
                                                                title={"Enter the maximum allowed retail price for the item"}
                                                                autoComplete='one-time-code'
                                                                label='MRP'
                                                                variant={'standard'}
                                                                fullWidth
                                                                className={clsx(classes.margin20t)}
                                                                name={"mrp"}
                                                                value={form?.mrp || ''}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    },
                                                                }}
                                                                id={idNamingConversion('MRP', 'product', 'TextField')}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                onChange={(e) => changeHandler(e)}
                                                                error={error.mrp ? true : false}
                                                                helperText={error.mrp}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Latest Purchase price</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {form?.latestPurchasePrice || '---'}
                                                                </Typography>
                                                            </> :
                                                            <TextField
                                                                autoComplete='one-time-code'
                                                                label='Latest Purchase price'
                                                                variant={'standard'}
                                                                fullWidth
                                                                className={clsx(classes.margin20t)}
                                                                name={"latestPurchasePrice"}
                                                                value={form?.latestPurchasePrice || ''}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    },
                                                                }}
                                                                id={idNamingConversion('Latest Purchase price', 'product', 'TextField')}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                onChange={(e) => changeHandler(e)}
                                                                error={error.latestPurchasePrice ? true : false}
                                                                helperText={error.latestPurchasePrice}
                                                            />
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xxl={9} xl={9} lg={9} md={16} sm={24} xs={24}>
                                            <Row gutter={20} >

                                                <Col xxl={15} xl={15} lg={15} md={13} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Cost Price</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {form?.costPrice || '---'}
                                                                </Typography>
                                                            </> :
                                                            <TextField autoComplete='one-time-code'
                                                                title={"Enter the cost price per unit for the item"}
                                                                label='Cost Price'
                                                                variant={'standard'}
                                                                fullWidth
                                                                name={"costPrice"}
                                                                value={form?.costPrice || ''}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    },
                                                                }}
                                                                id={idNamingConversion('Cost Price', 'product', 'TextField')}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                onChange={(e) => changeHandler(e)}
                                                                error={error.costPrice ? true : false}
                                                                helperText={error.costPrice}
                                                            />
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row type="flex" className={clsx(classes.productFormImageRow)} gutter={50}>
                                        <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                                            <Row gutter={20}>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Price Includes Tax</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.priceIncludesTax ? 'Yes' : 'No'}</Typography>
                                                            </> :
                                                            <FormControlLabel
                                                                classes={{
                                                                    label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                                                }}
                                                                control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                                    onChange={(e) => {
                                                                        setForm({ ...form, 'priceIncludesTax': !form.priceIncludesTax })
                                                                    }}
                                                                />}
                                                                id={idNamingConversion('Price Includes Tax', 'product', 'Radio')}
                                                                label="Price Includes Tax"
                                                                labelPlacement="top"
                                                                checked={form?.priceIncludesTax}
                                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                                        {
                                                            view ?
                                                                <>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Last Updated Date (MRP)</Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                        {form.mrpLastUpdatedDate ? moment(form.mrpLastUpdatedDate).format('DD MMM YYYY') : '---'}
                                                                    </Typography>
                                                                </> :
                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                    <DesktopDatePicker
                                                                        fullWidth
                                                                        slots={{
                                                                            openPickerIcon: DateIcon
                                                                        }}
                                                                        views={['year', 'month', 'day']}
                                                                        value={form?.mrpLastUpdatedDate || null}
                                                                        label={"Last Updated Date (MRP)"}
                                                                        name={"mrpLastUpdatedDate"}
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: classes.textFieldColor
                                                                            }
                                                                        }}
                                                                        slotProps={{
                                                                            textField: {
                                                                                id: idNamingConversion('Last Updated Date', 'product', 'TextField'),
                                                                                autoComplete: 'one-time-code'
                                                                            },
                                                                        }}
                                                                        format="dd/MM/yyyy"
                                                                        onChange={(newValue) => { changeHandler(newValue, 'mrpLastUpdatedDate') }}
                                                                    />
                                                                </LocalizationProvider>
                                                        }
                                                    </div>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                                        {
                                                            view ?
                                                                <>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Latest Purchase Price Date</Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                        {form.latestPurchasePriceTs ? moment(form.latestPurchasePriceTs).format('DD MMM YYYY') : '---'}
                                                                    </Typography>
                                                                </> :
                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                    <DesktopDatePicker
                                                                        fullWidth
                                                                        slots={{
                                                                            openPickerIcon: DateIcon
                                                                        }}
                                                                        views={['year', 'month', 'day']}
                                                                        value={form?.latestPurchasePriceTs || null}
                                                                        label="Latest Purchase Price Date"
                                                                        name={"latestPurchasePriceTs"}
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: classes.textFieldColor
                                                                            }
                                                                        }}
                                                                        slotProps={{
                                                                            textField: {
                                                                                id: idNamingConversion('Latest Purchase Price Date', 'product', 'TextField'),
                                                                                autoComplete: 'one-time-code'
                                                                            },
                                                                        }}
                                                                        format="dd/MM/yyyy"
                                                                        onChange={(newValue) => { changeHandler(newValue, 'latestPurchasePriceTs') }}
                                                                    />
                                                                </LocalizationProvider>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xxl={9} xl={9} lg={9} md={9} sm={24} xs={24}>
                                            <Row gutter={20}>
                                                <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                                                    <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                                        {
                                                            view ?
                                                                <>
                                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Last Updated Date (Cost Price)</Typography>
                                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                        {form.costLastUpdatedDate ? moment(form.costLastUpdatedDate).format('DD MMM YYYY') : '---'}
                                                                    </Typography>
                                                                </> :
                                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                    <DesktopDatePicker
                                                                        fullWidth
                                                                        slots={{
                                                                            openPickerIcon: DateIcon
                                                                        }}
                                                                        views={['year', 'month', 'day']}
                                                                        value={form?.costLastUpdatedDate || null}
                                                                        label="Last Updated Date (Cost Price)"
                                                                        name={"costLastUpdatedDate"}
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: classes.textFieldColor
                                                                            }
                                                                        }}
                                                                        slotProps={{
                                                                            textField: {
                                                                                id: idNamingConversion('Last Updated Date (Cost Price)', 'product', 'TextField'),
                                                                                autoComplete: 'one-time-code'
                                                                            },
                                                                        }}
                                                                        format="dd/MM/yyyy"
                                                                        onChange={(newValue) => { changeHandler(newValue, 'costLastUpdatedDate') }}
                                                                    />
                                                                </LocalizationProvider>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row type="flex" style={{ verticalAlign: 'middle' }} className={clsx(classes.productFormImageRow)} gutter={50}>
                                        <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                                            <Row gutter={20}>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                                </Col>
                                            </Row>
                                            <Row gutter={20} className={classes.marginTop10}>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Excise Applicable</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                    {form?.exciseApplicable ? 'Yes' : 'No'}
                                                                </Typography>
                                                            </> :
                                                            <FormControlLabel
                                                                classes={{
                                                                    label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                                                }}
                                                                control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                                    onChange={(e) => {
                                                                        setForm({ ...form, 'exciseApplicable': !form.exciseApplicable })
                                                                    }}
                                                                />}
                                                                id={idNamingConversion('Excise Applicable', 'product', 'Radio')}
                                                                label="Excise Applicable"
                                                                labelPlacement="top"
                                                                checked={form?.exciseApplicable}
                                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                            />
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    {/* <Row type="flex" className={clsx(classes.productFormImageRow)} gutter={50}>
                                        <Col xxl={15} xl={15} lg={15} md={24} sm={24} xs={24}>
                                            <Row gutter={20}>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>CESS</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.cess ? 'Yes' : 'No'}</Typography>
                                                            </> :
                                                            <FormControlLabel
                                                                classes={{
                                                                    label: clsx(classes.fonSize13, classes.noWrap, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'), // Pass your override css here
                                                                }}
                                                                control={<Switch size='small' className={clsx(classes.customSwitch)}
                                                                    onChange={(e) => {
                                                                        setForm({ ...form, 'cess': !form.cess })
                                                                    }}
                                                                />}
                                                                id={idNamingConversion('CESS', 'product', 'Radio')}
                                                                label="CESS"
                                                                labelPlacement="top"
                                                                checked={form?.cess}
                                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>GST CESS Type</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter(form?.cessType || '---')}</Typography>
                                                            </> :
                                                            <AutoCompleteComponent
                                                                name={["GST CESS Type"]}
                                                                heads={[{ 'key': 'label', 'name': 'Type' }]}
                                                                details={[
                                                                    { id: 'PERCENTAGE', label: 'Percentage' },
                                                                    { id: 'AMOUNT', label: 'Amount' }
                                                                ]}
                                                                id={idNamingConversion('GST CESS Type', 'product', 'DropDown')}
                                                                parentValue={customObject([
                                                                    { id: 'PERCENTAGE', label: 'Percentage' },
                                                                    { id: 'AMOUNT', label: 'Amount' }
                                                                ], form?.cessType)}
                                                                onChange={(data) => changeHandler(data.id, 'cessType')}
                                                                position={"top"}
                                                                topPosition={true}
                                                                disabled={!form?.cess}
                                                                customClasses={classes.margin20t}
                                                            />
                                                    }
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                                    {
                                                        view ?
                                                            <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>GST CESS Rate</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.cessRate || '---'}</Typography>
                                                            </> :
                                                            <TextField autoComplete='one-time-code'
                                                                title={"Enter the CESS Rate"}
                                                                label='CESS Rate'
                                                                variant={'standard'}
                                                                className={classes.margin20t}
                                                                fullWidth
                                                                name={"cessRate"}
                                                                value={form?.costPrice || ''}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    },
                                                                }}
                                                                id={idNamingConversion('CESS Rate', 'product', 'TextField')}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom,
                                                                }}
                                                                onChange={(e) => changeHandler(e)}
                                                            />
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row> */}
                                </> : <div className={classes.textAlignCenter}>
                                    <div className={classes.loadMoreCircle}></div>
                                </div>
                        }
                    </Box>
                }
            />
            <CustomAccordion
                title={"Product Unit Conversions"}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={
                    <>
                        {
                            productUnitConversiondetails.length > 0 &&
                            <>
                                <Row>
                                    <Col span={24} className={classes.textAlignRight}>
                                        <NavLink to="#" onClick={() => { setPrimaryTitle('Add'); handleOpen('unit') }} className={clsx(classes.customLink)}>
                                            <Image
                                                src={AddIcon}
                                                preview={false}
                                                className={clsx(classes.antImage)}
                                            />  <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Product unit Conversions</span>
                                        </NavLink>

                                    </Col>
                                </Row>
                                <CustomInfiniteScroll
                                    loadMore={productUnitConversionLoader}
                                    //loadMoreContent={loadMoreContent}
                                    heads={productUnitConversionHead}
                                    onRequestSort={(unitSortBy, unitSortOrder) => requestSort(unitSortBy, unitSortOrder)}
                                    sortOrder={unitSortOrder}
                                    sortBy={unitSortBy}
                                    customClasses={clsx(classes.tableRoot, classes.tableRootProduct)}
                                    //loadMoreTask={() => loadMoreTask()}
                                    component={
                                        <>
                                            {
                                                productUnitConversionLoader ? (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className={classes.textAlignCenter} colSpan={7}><div className={classes.loadMoreCircle}></div></TableCell>
                                                    </TableRow>
                                                ) : (
                                                    <React.Fragment>
                                                        {
                                                            productUnitConversiondetails && Array.isArray(productUnitConversiondetails) && productUnitConversiondetails.length > 0 ? productUnitConversiondetails.map((data, i) => (
                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                                    <TableCell style={{ width: getColumnWidth(productUnitConversionHead, 0) }}><NavLink style={{ width: getColumnWidth(productUnitConversionHead, 0) }} to={"#"} className={clsx(classes.color, classes.bold)} onClick={() => onEdit('unit', data, true)}>{data?.id || '---'}</NavLink></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(productUnitConversionHead, 1) }}><NavLink style={{ width: getColumnWidth(productUnitConversionHead, 1) }} to={"#"} className={clsx(classes.color, classes.bold)} onClick={() => onEdit('unit', data, true)}>{data?.product?.productName || '---'} </NavLink></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(productUnitConversionHead, 2) }}><span style={{ width: getColumnWidth(productUnitConversionHead, 2) }}>{data?.product?.productId || '---'}</span></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(productUnitConversionHead, 3) }}><span style={{ width: getColumnWidth(productUnitConversionHead, 3) }}>{data?.unit?.name || '---'}</span></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(productUnitConversionHead, 4) }}><span style={{ width: getColumnWidth(productUnitConversionHead, 4) }}>{data?.toUnit?.name || '---'}</span></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(productUnitConversionHead, 5) }}><span style={{ width: getColumnWidth(productUnitConversionHead, 5) }}>{data?.conversionFactor || '---'}</span></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(productUnitConversionHead, 6) }}><span style={{ width: getColumnWidth(productUnitConversionHead, 6) }}>{data?.additionalFactor || '---'}</span></TableCell>
                                                                    <TableCell>
                                                                        <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                                            <NavLink to={"#"} onClick={() => onEdit('unit', data, true)}>
                                                                                <Image src={ViewIcon} preview={false} />
                                                                            </NavLink>
                                                                            <NavLink to={"#"} onClick={() => onEdit('unit', data)}>
                                                                                <Image src={EditIcon} preview={false} />
                                                                            </NavLink>
                                                                            <NavLink to={"#"} onClick={() => handleDelete('unit', data)} >
                                                                                <Image src={DeleteIcon} preview={false} />
                                                                            </NavLink>
                                                                        </Space>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : (
                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                    <TableCell className={classes.textAlignCenter} colSpan={7}>
                                                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>No results found</p>

                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        }
                                                    </React.Fragment>
                                                )
                                            }
                                        </>
                                    }
                                />
                            </>
                        }
                        {
                            productUnitConversiondetails.length === 0 && (
                                <div className={clsx(classes.noItems, classes.textAlignCenter)}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, classes.textAlignCenter)}>Startby Adding Product Unit Conversions</Typography>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={() => { setPrimaryTitle('Add'); handleOpen('unit') }}
                                        className={clsx(classes.modalBtn, classes.margin20t, { [classes.disabled]: !productId })}
                                    >Add Product unit Conversions</Button>
                                </div>
                            )
                        }
                    </>
                }
            />
            <CustomAccordion
                title={"Batch Details"}
                top={"116"}
                topVisible={"250px"}
                zIndex={5}
                showDetails={showDetails}
                index={2}
                ref={childRef}
                component={
                    <>
                        {
                            batch.length > 0 &&
                            <>
                                <Row>
                                    <Col span={24} className={classes.textAlignRight}>
                                        <NavLink to="#" onClick={() => handleOpen('batch')} className={clsx(classes.customLink)}>
                                            <Image
                                                src={AddIcon}
                                                preview={false}
                                                className={clsx(classes.antImage)}
                                            />  <span className={clsx(classes.addLink, classes.color, classes.bold, { [classes.disabled]: productId === undefined })}>Add Batch Details</span>
                                        </NavLink>
                                    </Col>
                                </Row>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{'Batch ID'}</TableCell>
                                                <TableCell>{'Batch No.'}</TableCell>
                                                <TableCell>{'Quantity'}</TableCell>
                                                <TableCell>{'Expiry Date'}</TableCell>
                                                <TableCell>{'Best Before | Use By Date'}</TableCell>
                                                <TableCell>{'Batch Mfg Date'}</TableCell>
                                                <TableCell className={classes.textAlignRight}><span className={classes.linesActionColumn} style={{ width: '70px' }}>{'Actions'}</span></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                batch.map((data, i) => (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                        <TableCell>{data?.batchId || '---'}</TableCell>
                                                        <TableCell>{data?.batchNumber || '---'}</TableCell>
                                                        <TableCell>{data?.quantity || '---'}</TableCell>
                                                        <TableCell>{data?.expiryDate ? dayjs(data.expiryDate).format('DD/MM/YYYY') : '---'}</TableCell>
                                                        <TableCell>{data?.bestDate ? dayjs(data.bestDate).format('DD/MM/YYYY') : '---'}</TableCell>
                                                        <TableCell>{data?.mfgDate ? dayjs(data.mfgDate).format('DD/MM/YYYY') : '---'}</TableCell>
                                                        <TableCell className={classes.textAlignRight}>
                                                            <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                                <NavLink to={"#"} onClick={() => onEdit('batch', data, i)}>
                                                                    <Image
                                                                        src={EditIcon}
                                                                        preview={false}
                                                                    />
                                                                </NavLink>
                                                                <NavLink to={"#"} onClick={() => handleDelete('batch', data)}>
                                                                    <Image
                                                                        src={DeleteIcon}
                                                                        preview={false}
                                                                    />
                                                                </NavLink>
                                                            </Space>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </>
                        }
                        {
                            batch.length === 0 && (
                                <div className={clsx(classes.noItems, classes.textAlignCenter)}>
                                    <Typography variant={'subtitle1'}
                                        className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, classes.textAlignCenter)}>
                                        Startby Adding Batch Details</Typography>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={() => handleOpen('batch')}
                                        className={clsx(classes.modalBtn, classes.margin20t, { [classes.disabled]: !productId })}
                                    >Add Batch Details</Button>
                                </div>
                            )
                        }
                    </>
                }
                lastContent={true}
            />
            <UnitForm
                visible={unitVisible}
                handleSubmit={(e) => handleUnitSubmit(e)}
                handleClose={() => handleOpen('unit')}
                handleAddMore={(e, form) => handleAddMore(e, form)}
                onView={() => setFormView(false)}
                onEdit={(data) => { onEdit('unit', data); setUnitVisible(true) }}
                form={unitForm}
                productForm={form}
                unitMesurementdetails={unitMesurementdetails}
                unitClassdetails={unitClassdetails}
                customObject={(details, id) => customObject(details, id)}
                changeHandler={(e, name) => changeUnitHandler(e, name)}
                error={unitError}
                title={primaryTitle}
                unitId={unitId}
                view={formView}
                formRelation={unitFormRelation}
            />
            <BatchForm
                visible={batchVisible}
                handleSubmit={(e) => handleBatchSubmit(e)}
                handleClose={() => handleOpen('batch')}
                handleAddMore={(e, form) => handleAddMore(e, form)}
                form={batchForm}
                productForm={form}
                customObject={(details, id) => customObject(details, id)}
                changeHandler={(e, name) => changeBatchHandler(e, name)}
                error={batchError}
                title={primaryTitle}
            />
            <DeleteModal onClose={(v) => { setDeleteModalVisible(false) }}
                id={formType === 'unit' ? unitId : batchId}
                loadTasks={() => dispatchFilter(unitSortBy, unitSortOrder)} name={formType === 'unit' ? `the Unit conversions with Unit ID ${unitId}` : ''}
                url={formType === 'unit' ? 'product-unit-conversions' : ''}
                title={formType === 'unit' ? 'Product unit conversions' : ''} visible={deleteModalVisible} />

            <DeleteModal onClose={(v) => { setDeleteModal(false) }}
                id={productId}
                loadTasks={() => history.push("/product/product/my-products")} name={form.productName} url={'client-products'}
                title={'Client Products'} visible={deleteModal} />
        </>

    )
})